import styled from 'styled-components'

const Icon = styled.img`
  margin-right: 1rem;
`

export default Icon